module.exports = new __parcel__URL__("goals-preview-dark.0421fbf5.svg").toString();